import React from 'react';
import { QuestRoute } from '../../api/QuestRoutes';
import { Enum, formatCurrency, generateId, translate } from '../../utility/functions';
import Table from '../../table/Table';
import Button from '../../forms/Button';
import HamQuest from '../../api/HamQuestGiver';
import Form from '../../forms/Form';
import GetState from '../../GetState';
import Radio from '../../forms/Radio';
import Input from '../../forms/Input';
import Preput from '../../forms/Preput';
import Select from '../../forms/Select';
import { HSOptions } from '../../../constants/HSOptions';
import LocationSelectors from '../../forms/formComponents/LocationSelectors';
import TerminalIDsSelector from '../../forms/formComponents/TerminalIDsSelector';
import { userRoles } from '../../RoleProtected';
import ManagementRow from '../../table/ManagementRow';
import ModalFactory from '../../Modal';
import UpgradeAndAutoSelect from '../../forms/formComponents/UpgradeAndAutoSelect';

const Awards = ({ ...props }) => {

    const loyaltyType = {
        fleetPass: 'FleetPass',
        dailyPass: 'DailyPass',
        prepaidPass: 'PrepaidPass',
    };

    const FleetForm = ({ values, ...props }) => {
        return (
            <>
                <Select
                    label='Award Type'
                    name='awardType'
                    options={HSOptions.expressPass.fleetAwardType}
                    required
                />
                <Input
                    label='Item Price'
                    name='awardValue'
                    type='price'
                    required
                    disable={values.awardType !== 'ItemRate'}
                />
                <Radio
                    label='Item'
                    name='kioskItemId'
                    getOptions={QuestRoute.kiosks.wash}
                    buildOptions={e => {
                        e.label = e.name
                        e.value = e.id
                    }}
                    required
                />
            </>
        )
    }

    const PrePaidForm = ({ values, ...props }) => {
        return (
            <>
                <Select
                    label='Award Type'
                    name='awardType'
                    options={HSOptions.expressPass.awardItemType}
                    required
                />

                <Input
                    label='Discount Value'
                    name='awardValue'
                    type='price'
                    required
                    disable={values.awardType === 'Item'}
                />
                <Input
                    label='Package Price'
                    name='packagePrice'
                    type='price'
                    required
                />

                <Select
                    label='Billing Cycle'
                    name='billingCycle'
                    options={HSOptions.expressPass.billingCycle}
                    required
                />

                <Radio
                    label='Item'
                    name='kioskItemId'
                    getOptions={QuestRoute.kiosks.wash}
                    buildOptions={e => {
                        e.label = e.name
                        e.value = e.id
                    }}
                    
                    disable={values.awardType === 'DollarDiscTrans'}
                    required = {values.awardType === 'DollarDiscTrans' ? true : false}
                />
            </>
        )
    }

    const DailyForm = ({ values, ...props }) => {
        return (
            <>
                <Select
                    label='Award Type'
                    name='awardType'
                    options={HSOptions.expressPass.fleetAwardType}
                    required
                />
                <Input
                    label='Item Price'
                    name='awardValue'
                    type='price'
                    required
                    disable={values.awardType !== 'ItemRate'}
                />
                <Radio
                    label='Item'
                    name='kioskItemId'
                    getOptions={QuestRoute.kiosks.wash}
                    buildOptions={e => {
                        e.label = e.name
                        e.value = e.id
                    }}
                    required
                />
            </>
        )
    }


    const AwardForm = ({ values, type, ...props }) => {
        return (
            <>
                <Input
                    label='Name'
                    name='name'
                    required
                />
                <Preput
                    label='Details'
                    name='description'
                />

                {type === loyaltyType.fleetPass && <FleetForm values={values} />}
                {type === loyaltyType.dailyPass && <DailyForm values={values} />}
                {type === loyaltyType.prepaidPass && <PrePaidForm values={values} />}

                <Input
                    label='SKU'
                    name='sku'
                />

                <UpgradeAndAutoSelect isAward={true} autoSelectFieldName='autoSelectItem' />

                <LocationSelectors />

                <TerminalIDsSelector />
            </>
        )
    }

    const [awards, refreshAwards] = GetState(QuestRoute.expressPass.awards)

    const deleteAward = (award) => {
        ModalFactory.confirmAndProcess({
            confirmation: {
                title: `Are you sure?`,
                body: `Are you sure you want to delete ${award.name}?`,
                type: 'warning',
            },
            promise: {
                title: 'Deleting Wash Club',
                body: `Deleting ${award.name}`,
                callback: () => HamQuest.delete(QuestRoute.expressPass.editAward(award.awardId))
            },
            confirmed: {
                title: 'Success',
                body: `${award.name} successfully deleted.`,
                type: 'success'
            },
            finally: () => refreshAwards()
        })
    }

    const editAward = (award) => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: `Edit ${award.name}`,
            body: (
                <Form
                    name='expressPassSettings'
                    inputs={{ ...award }}
                    onSubmit={e => HamQuest.put(QuestRoute.expressPass.editAward(e.awardId), { ...e })
                        .then(() => {
                            refreshAwards();
                            ModalFactory.close(id);
                        })
                    }
                    text='Update'
                >
                    {({ values }) => <AwardForm values={values} type={award.loyaltyType} />}
                </Form>
            )
        })
    }

    const addNewAward = (type) => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: `Add a new Award`,
            body: (
                <Form
                    name='expressPassSettings'
                    inputs={{
                        name: '',
                        description: '',
                        loyaltyType: type,
                        awardType: '',
                        packagePrice: '',
                        discountValue: '',
                        billingCycle: 1,
                        monthlyFee: '',
                        sku: '',
                        kioskItemId: '',
                        kioskType: '',
                        itemType: '',
                        price: '',
                        locations: [],
                        allowUpgrades: '',
                        autoSelectItem: '',
                    }}
                    onSubmit={e => HamQuest.post(QuestRoute.expressPass.awards, { ...e })
                        .then(() => {
                            refreshAwards();
                            ModalFactory.close(id);
                        })
                    }
                    text='Add Award'
                >
                    {({ values }) => <AwardForm values={values} type={type} />}
                </Form>
            )
        })
    }


    const tableConfig = {
        data: awards,
        controls: [
            <Button roles={userRoles.editProducts} onClick={() => addNewAward(loyaltyType.fleetPass)}>Add Fleet Plan</Button>,
            <Button roles={userRoles.editProducts} onClick={() => addNewAward(loyaltyType.prepaidPass)}>Add Pre-Paid Plan</Button>,
            <Button roles={userRoles.editProducts} onClick={() => addNewAward(loyaltyType.dailyPass)}>Add Daily  Plan</Button>,
        ],
        headers: [
            {
                label: 'Name',
                propKey: 'name',
            }, {
                label: 'Loyalty Type',
                propKey: 'loyaltyType',
                options: true,
            }, {
                label: 'Award Type',
                propKey: 'awardType',
                options: true,
            }, {
                label: 'Billing Cycle',
                propKey: 'billingCycle',
                options: true,
            }, {
                label: 'Package Price',
                propKey: 'packagePrice',
                type: 'number'
            }, {
                label: 'Item Rate',
                propKey: 'awardValue',
                type: 'number'
            }, {
                label: 'Discount Value',
                propKey: 'discountValue',
                type: 'number'
            }, {
                label: 'Allow Upgrades',
                propKey: 'allowUpgrades',
                options: true,
            }, {
                label: 'Auto Select Item',
                propKey: 'autoSelectItem',
                options: true,
            },
        ],
        renderFormat: (e) => (

            <ManagementRow
                key={generateId()}
                controls={[
                    <Button roles={userRoles.editProducts} key={generateId()} onClick={() => editAward(e)}>Edit</Button>,
                    <Button roles={userRoles.editProducts} key={generateId()} onClick={() => deleteAward(e)}>Delete</Button>
                ]}
            >
                <td>{e.name}</td>
                <td>{translate(e.loyaltyType)}</td>
                <td>{translate(e.awardType)}</td>
                <td>{e.billingCycle}</td>
                <td>{formatCurrency(findPrice('packagePrice', e) ?? 0)}</td>
                <td>{formatCurrency(findPrice('itemRate', e) ?? 0) }</td>
                <td>{formatCurrency(findPrice('discountValue', e) ?? 0)}</td>
                <td>{translate(e.allowUpgrades)}</td>
                <td>{translate(e.autoSelectItem)}</td>
            </ManagementRow>
                        
        )
            
    }

    return (<Table config={tableConfig} />);
}

const findPrice = (column, data) => {
    let price = 0;
    if (data.awardType === 'Item') {
        return price;
    }
    switch (column) {        
        case 'packagePrice':
            if (data.awardType === 'ItemRate') {
                price = 0;
            }else if (data.awardType === 'DollarDiscTrans' || data.awardType === 'DollarDiscItem') {
                price = data.packagePrice;
            }
            break;
        case 'itemRate':
            if (data.awardType === 'ItemRate') {
                price = data.awardValue;
            }
            break;
        case 'discountValue':
            if (data.awardType === 'ItemRate') {
                price = 0;
            }else if (data.awardType === 'DollarDiscTrans' || data.awardType === 'DollarDiscItem') {
                price = data.awardValue;
            }
            break;
    }
    return price;
};

export default Awards;